import { mdiTune } from '@mdi/js';
import type {
  LabeledValue,
  ParsedConfigurationItem,
  RenderSettingsScope,
  RenderSettingsType
} from 'common/models';
import { useEditConfigurationMutationV2 } from 'common/queries';
import IconText from 'components/IconText/IconText';
import { getConfigurationItemToSave } from 'helpers/renderSettings';
import { useCustomTranslation } from 'helpers/translationHelper';
import React, { useState } from 'react';

import RenderSettingsDrawer from './RenderSettingsDrawer';

interface Props {
  scope: RenderSettingsScope;
  type: RenderSettingsType;
  optionsToHide?: string[];
  // Use for dynamic options, like serivceObjectRevisionCategories
  additionalOptions?: LabeledValue[];
  parsedConfigurationItem?: ParsedConfigurationItem;
}

const RenderSettingsDrawerWrapper: React.FC<Props> = (props): React.ReactElement => {
  const { scope, type, optionsToHide, parsedConfigurationItem, additionalOptions } = props;

  const { t } = useCustomTranslation();

  const editConfigurationMutation = useEditConfigurationMutationV2();

  const [drawerIsVisible, setIsDrawerVisible] = useState(false);

  const handleSettingsConfirm = (values: string[]) => {
    const itemToSave = getConfigurationItemToSave(values, scope, type, parsedConfigurationItem);

    editConfigurationMutation.mutate(itemToSave);
  };

  return (
    <>
      <div onClick={() => setIsDrawerVisible(true)} className="RenderSettingsDrawer">
        <IconText iconPath={mdiTune} text={t('renderSettings.renderSettingsButton')} />
      </div>
      <RenderSettingsDrawer
        scope={scope}
        type={type}
        optionsToHide={optionsToHide}
        additionalOptions={additionalOptions}
        parsedConfigurationItem={parsedConfigurationItem}
        onClose={() => setIsDrawerVisible(false)}
        open={drawerIsVisible}
        onConfirm={(fieldIds) => {
          handleSettingsConfirm(fieldIds);
          setIsDrawerVisible(false);
        }}
      />
    </>
  );
};

export default RenderSettingsDrawerWrapper;
